import { TranslationKey } from '../functions/i18n';

export const en: Record<TranslationKey, string> = {
  'nav.records': 'Vitals',
  'nav.meds': 'Meds',
  'nav.guide': 'Library',
  'nav.options': 'Reminders',
  'topbar.welcome': 'Welcome',
  'splash.tagline': 'Master Pet Health. Conquer the Fellowship.',
  'records.tab.todayEntry': 'Daily',
  'records.tab.allCards': 'History',
  'records.tab.worksheet': 'Data',
  'meds.title': 'Medications & Treatments',
  'meds.empty': 'No medications or treatments added yet',
  'trends.title': 'Trends',
  'trends.noDataTitle': 'No Data Yet',
  'trends.noDataBody': 'Start logging your vitals in the Cards tab to see trends here.',
  'trends.moreDataNeeded': 'More Data Needed',
  'trends.moreDataNeededBody': 'We need at least 3 days of logged data to start generating trends. Keep at it!',
  'trends.avgWeight': 'Avg Weight',
  'trends.avgHeartRate': 'Avg Heart Rate',
  'trends.avgRespRate': 'Avg Respiratory Rate',
  'trends.avgMucousMembrane': 'Avg Mucous Membrane',
  'trends.avgWaterIntake': 'Avg Water Intake',
  'trends.avgTemperature': 'Avg Temperature',
  'trends.weightTrend': 'Weight Trend',
  'trends.heartRateTrend': 'Heart Rate Trend',
  'trends.respRateTrend': 'Respiratory Rate Trend',
  'trends.mucousMembraneTrend': 'Mucous Membrane Distribution',
  'trends.fluidIntakeTrend': 'Water Intake Trend',
  'trends.foodIntakeTrend': 'Food Intake Trend',
  'trends.avgFoodIntake': 'Avg Food Intake',
  'trends.day': 'day',
  'trends.days': 'days',
  'trends.tooltipWeight': 'Weight',
  'trends.tooltipFluid': 'Fluid Intake',
  'trends.tooltipFood': 'Food Intake',
  'trends.tooltipHeartRate': 'Heart Rate',
  'trends.tooltipRespRate': 'Resp. Rate',
  'trends.tooltipMucousMembrane': 'Mucous Membrane',
  'trends.fluidBalanceTrend': 'Fluid Balance Trend',
  'trends.tempTrend': 'Temperature Trend',
  'trends.moodTrend': 'Mood Trend',
  'trends.mucousMembrane.pink': 'Pink',
  'trends.mucousMembrane.red': 'Red',
  'trends.mucousMembrane.blue': 'Blue',
  'trends.mucousMembrane.white': 'White',
  'trends.noMucousMembraneData': 'No mucous membrane entries were logged in this time range yet.',
  'trends.moodLabel.terrible': 'Terrible',
  'trends.moodLabel.notGreat': 'Not great',
  'trends.moodLabel.okay': 'Okay',
  'trends.moodLabel.good': 'Good',
  'trends.moodLabel.great': 'Great',
  'trends.tooltipFluidBalance': 'Fluid Balance',
  'trends.tooltipTemp': 'Temperature',
  'trends.tooltipMood': 'Mood',
  'trends.customise': 'Customise',
  'trends.resetLayout': 'Reset Layout',
  'trends.viewPlans': 'View Plans',
  'trends.trendsLockedTitle': 'Trends Are a Paid Feature',
  'trends.trendsLockedBody': 'Subscribe to KodaCare to track your pet\'s weight, temperature, water intake, and more over time.',
  'trends.lifetimeLockedTitle': 'Expert Companion Feature',
  'trends.lifetimeLockedBody': 'Upgrade to the Expert Companion plan to unlock respiratory rate, mucous membrane, and temperature trends — plus a fully customisable chart layout.',
  'guide.digestLockedTitle': 'Monthly Pet Health Digest',
  'guide.digestLockedBody': 'Upgrade to the Expert Companion plan to receive our curated monthly newsletter — the most significant news in pet health, veterinary research, and stories from the pet parent community.',
  'options.title': 'Notifications',
  'options.appPreferences': 'App Preferences',
  'options.language': 'Language',
  'options.units': 'Units',
  'options.metric': 'Metric',
  'options.imperial': 'Imperial',
  'options.dateFormat': 'Date Format',
  'options.timeFormat': 'Time Format',
  'options.transplant': 'Pet Profile',
  'options.editProfile': 'Edit Profile',
  'options.saveToHomeScreen': 'Install App',
  'options.logOut': 'Log Out',
  'options.fullName': 'Full Name',
  'options.profession': 'Profession',
  'options.professionPlaceholder': 'e.g. Vet, Pet Parent',
  'options.emailAddress': 'Email Address',
  'options.emailCannotChange': 'Email cannot be changed.',
  'options.transplantDate': "Pet's Date of Birth",
  'options.changePassword': 'Change Password',
  'options.deleteAccount': 'Delete Account',
  'options.cancel': 'Cancel',
  'options.saveChanges': 'Save Changes',
  'login.email': 'Email',
  'login.password': 'Password',
  'login.forgotPassword': 'Forgot password?',
  'login.signIn': 'Sign In',
  'login.continueWithGoogle': 'Continue with Google',
  'login.noAccount': "Don't have an account?",
  'login.register': 'Register',
  'login.or': 'or',
  'login.rememberMe': 'Remember me for 30 days',
  'forgot.title': 'Reset your password',
  'forgot.subtitle': "Enter your email and we'll send you a link to reset your password.",
  'forgot.checkInboxTitle': 'Check your inbox',
  'forgot.checkInboxBody': 'We sent a password reset link to {email}. Follow the link to choose a new password.',
  'forgot.spamHint': "Didn't receive it? Check your spam or junk folder.",
  'forgot.backToSignIn': 'Back to Sign In',
  'forgot.sendResetLink': 'Send Reset Link',
  'forgot.rememberPassword': 'Remember your password?',
  'forgot.legal': 'By signing in, you agree to our Terms of Service and Privacy Policy.',
  'forgot.errorNoAccount': 'No account found with that email address.',
  'forgot.errorNetwork': 'Network error. Check your connection and try again.',
  'forgot.errorGeneric': 'Could not send reset email. Please try again.',
  'verify.title': 'Verify your email',
  'verify.subtitle': 'We sent a verification link to {email}. Click the link in that email, then come back and sign in.',
  'verify.errorResend': 'Could not resend the email. Please try again in a moment.',
  'verify.resent': 'Verification email resent — check your inbox.',
  'verify.emailSent': 'Email Sent ✓',
  'verify.resend': 'Resend Verification Email',
  'verify.backToSignIn': 'Back to Sign In',
  'verify.spamHint': "Didn't receive it? Check your spam or junk folder.",
  'authAction.loading': 'Validating your link…',
  'authAction.error.missingInfo': 'This confirmation link is missing required information.',
  'authAction.error.unsupportedMode': 'This action type is not supported on this page yet.',
  'authAction.error.expired': 'This link has expired. Please request a new one.',
  'authAction.error.invalid': 'This link is invalid or has already been used.',
  'authAction.error.userDisabled': 'This account is disabled.',
  'authAction.error.userNotFound': 'No account was found for this link.',
  'authAction.error.weakPassword': 'Your new password is too weak. Please choose a stronger password.',
  'authAction.error.generic': 'We could not process this link. Please request a new one and try again.',
  'authAction.error.resetInvalid': 'This reset link is invalid. Please request a new one.',
  'authAction.error.passwordMin': 'Password must be at least 8 characters.',
  'authAction.error.passwordMismatch': 'Passwords do not match.',
  'authAction.verifySuccessTitle': 'Email confirmed',
  'authAction.verifySuccessBody': 'Your email is now verified. You can sign in to continue.',
  'authAction.recoverSuccessTitle': 'Email restored',
  'authAction.recoverSuccessBody': 'Your email change was reverted successfully. Please sign in again.',
  'authAction.continue': 'Continue',
  'authAction.goToSignIn': 'Go to Sign In',
  'authAction.resetTitle': 'Set a new password',
  'authAction.resetBody': 'Resetting password for {email}',
  'authAction.newPassword': 'New password',
  'authAction.confirmNewPassword': 'Confirm new password',
  'authAction.updatePassword': 'Update Password',
  'authAction.resetSuccessTitle': 'Password updated',
  'authAction.resetSuccessBody': 'Your password has been reset successfully.',
  'authAction.signIn': 'Sign In',
  'authAction.linkUnavailableTitle': 'Link unavailable',
  'authAction.requestNewResetLink': 'Request a new reset link',
  'authAction.backToSignIn': 'Back to Sign In',
  'register.title': 'Create your account',
  'register.fullName': 'Full Name',
  'register.operationDate': "Pet's Date of Birth",
  'register.email': 'Email',
  'register.password': 'Password',
  'register.confirmPassword': 'Confirm Password',
  'register.createAccount': 'Create Account',
  'register.haveAccount': 'Already have an account?',
  'register.signIn': 'Sign In',
  'guide.comingSoon': 'Coming soon',
  'guide.motivation': "You've got this! Your companion is lucky to have you.",
  // Records page
  'records.todaysOverview': "Today's Overview",
  'records.selectedDayOverview': 'Selected Day Overview',
  'records.weight': 'Weight',
  'records.fluids': 'Intake',
  'records.fluidIntake': 'Water Intake',
  'records.foodIntake': 'Food Intake',
  'records.urineOutput': 'Urine Output',
  'records.saveWeight': 'Save Weight',
  'records.undoWeight': 'Undo weight',
  'records.weightRecorded': 'Weight Recorded',
  'records.weightRecordedToday': 'Weight Recorded Today',
  'records.add': 'Add',
  'records.total': 'total',
  'records.morningVitals': 'Morning Check',
  'records.afternoonVitals': 'Afternoon Check',
  'records.morningVitalsRecorded': 'Morning Check Recorded',
  'records.afternoonVitalsRecorded': 'Afternoon Check Recorded',
  'records.saveVitals': 'Save Vitals',
  'records.resetTodaysData': "Reset Today's Data",
  'records.resetConfirmMessage': "This will delete all of today's recorded data. This cannot be undone.",
  'records.dailyLimitReached': 'Daily limit reached (9999ml)',
  'records.newEntry': 'New Entry',
  'records.addNewEntry': 'Add New Entry',
  'records.saveEntry': 'Save Entry',
  'records.cancel': 'Cancel',
  'records.date': 'Date',
  'records.morning': 'Morning',
  'records.afternoon': 'Afternoon',
  'records.daily': 'Daily',
  'records.bpSystolic': 'BP Systolic',
  'records.bpDiastolic': 'BP Diastolic',
  'records.pulse': 'Pulse',
  'records.temp': 'Temp',
  'records.downloadCsvFor': 'Download CSV for:',
  'records.thisWeek': 'This Week',
  'records.thisMonth': 'This Month',
  'records.thisYear': 'This Year',
  'records.shareDataTitle': 'Share data with your vet',
  'records.dataCopiedToClipboard': 'Data copied to clipboard! You can now paste it into an email or message to share with your vet.',
  'records.noLogEntriesYet': 'No log entries yet',
  'records.fillAtLeastOneField': 'Please fill in at least one field',
  'records.fluid': 'Fluid',
  'records.amBp': 'AM BP',
  'records.amPulse': 'AM Pulse',
  'records.amTemp': 'AM Temp',
  'records.pmBp': 'PM BP',
  'records.pmPulse': 'PM Pulse',
  'records.pmTemp': 'PM Temp',
  'records.vitals': 'Vitals',
  'records.vitalsTime': 'Vitals:',
  'records.filterBy': 'Filter by:',
  'records.week': 'Week',
  'records.month': 'Month',
  'records.year': 'Year',
  'records.entry': 'entry',
  'records.entries': 'entries',
  'records.today': 'Today',
  'records.fluidIn': 'Fluid In',
  'records.deleteLogEntry': 'Delete this log entry?',
  'records.undoWeightEntry': 'Undo weight entry',
  'records.undoLastFluidEntry': 'Undo last fluid entry',
  'records.undoLastUrineEntry': 'Undo last urine entry',
  'records.toolbar.addNote': '+ Add note',
  'records.toolbar.editNote': 'Edit note',
  'records.toolbar.intake': 'Intake',
  'records.toolbar.saveNote': 'Save note',
  'records.toolbar.updateNote': 'Update note',
  'records.toolbar.notesPlaceholder': 'What to note — coughing or sneezing, stress due to life events.\nor\nChanges in the following — discharge, sleep, appetite, water intake.',
  'records.toolbar.add': 'Add',
  'records.toolbar.save': 'Save',
  'records.undoMorningVitals': 'Undo morning vitals',
  'records.undoAfternoonVitals': 'Undo afternoon vitals',
  'records.amount': 'Amount',
  'records.tab.documents': 'Vault',
  'records.documentsTitle': 'Document Vault',
  'records.documentsSubtitle': 'Keep your vet records, vaccination certs, and insurance docs organised in one secure place.',
  'records.searchDocuments': 'Search documents…',
  'records.uploadDocument': 'Upload File',
  'records.takePhoto': 'Take Photo',
  'records.maxFilesReached': 'File cap reached for this account. Delete older files to add more.',
  'records.categoryAll': 'All',
  'records.bucketLabs': 'Blood Tests',
  'records.bucketScans': 'Scans & X-rays',
  'records.bucketLetters': 'Vet Letters',
  'records.bucketDischarge': 'Discharge Papers',
  'records.bucketPrescriptions': 'Prescriptions',
  'records.bucketOther': 'Other',
  'records.noDocumentsYet': 'No documents yet',
  'records.titleOptional': 'Title (optional)',
  'records.noteOptional': 'Note (optional)',
  'records.documentDate': 'Document date',
  'records.uploading': 'Uploading…',
  'records.openFile': 'Open',
  'records.deleteFile': 'Delete',
  'records.deleteFileConfirm': 'Delete this file from your vault?',
  'records.dateAlreadyHasEntry': 'This date already has an entry. Use the edit button in the table to modify it.',
  'records.deleteEntry': 'Delete Entry',
  'records.deleteEntryConfirm': 'Are you sure you want to delete all data for this date?',
  'records.editEntry': 'Edit Entry',
  'records.observations': 'Observations',
  'records.howAreYouFeeling': 'How are you feeling today?',
  'records.observationsPlaceholder': 'What to note — coughing or sneezing, stress due to life events.\nor\nChanges in the following — discharge, sleep, appetite, water intake.',
  'records.saveObservations': 'Save Observations',
  'records.observationsRecorded': 'Observations Recorded',
  'records.undoObservations': 'Undo observations',
  'records.moodTerribleLabel': 'Terrible',
  'records.moodBadLabel': 'Not great',
  'records.moodOkayLabel': 'Okay',
  'records.moodGoodLabel': 'Good',
  'records.moodGreatLabel': 'Great',
  'records.noObservations': 'No observations',
  'records.mood': 'Mood',
  // Notification Center
  'notifications.title': 'All Reminders',
  'notifications.allReminders': 'All Reminders',
  'notifications.storageNote': 'The last 5 days of reminders are shown.',
  'notifications.new': 'new',
  'notifications.markAllRead': 'Mark all as read',
  'notifications.allCaughtUp': 'All caught up!',
  'notifications.clearAll': 'Clear all',
  'notifications.clearAllConfirm': 'Tap again to clear all',
  // Delete Confirm Modal
  'deleteConfirm.defaultTitle': 'Delete this item?',
  'deleteConfirm.cancel': 'Cancel',
  'deleteConfirm.delete': 'Delete',
  'deleteConfirm.dontShowAgain': "Don't show again",
  // Settings Panel
  'settings.title': 'Settings',
  'settings.preferences': 'Preferences',
  'settings.language': 'Language',
  'settings.units': 'Units',
  'settings.metric': 'Metric',
  'settings.imperial': 'Imperial',
  'settings.dateFormat': 'Date Format',
  'settings.timeFormat': 'Time Format',
  'settings.logOut': 'Log Out',
  'settings.editProfile': 'Edit Profile',
  'settings.fullName': 'Full Name',
  'settings.profession': 'Profession',
  'settings.professionPlaceholder': 'e.g. Vet, Pet Parent',
  'settings.emailAddress': 'Email Address',
  'settings.emailCannotChange': 'Email cannot be changed.',
  'settings.transplantDate': "Pet's Date of Birth",
  'settings.changePassword': 'Change Password',
  'settings.deleteAccount': 'Delete Account',
  'settings.deleteAccountConfirm': 'Are you sure you want to delete your account? This action cannot be undone.',
  'deleteAccount.title': 'Delete your account?',
  'deleteAccount.bullet1': 'You will be signed out immediately and will no longer be able to log in.',
  'deleteAccount.bullet2': 'Your health records, medications, and all personal data will be permanently deleted within 30 days.',
  'deleteAccount.bullet3': 'Active subscriptions will not be automatically cancelled — please cancel them separately in Settings.',
  'deleteAccount.footer': 'This action cannot be undone.',
  'deleteAccount.confirm': 'Yes, delete my account',
  'deleteAccount.cancel': 'Keep my account',
  'settings.cancel': 'Cancel',
  'settings.saveChanges': 'Save Changes',
  // Meds page
  'meds.removeMedication': 'Remove Medication',
  'meds.removeConfirm': 'Are you sure you want to remove this medication?',
  'meds.medCount': 'med',
  'meds.medsCount': 'meds',
  'meds.remindersEnabled': 'Reminders enabled',
  'meds.remindersDisabled': 'Reminders disabled',
  'meds.addMedication': 'Add Medication',
  'meds.cancel': 'Cancel',
  'meds.medicationName': 'Medication Name',
  'meds.medicationNamePlaceholder': 'e.g. Apoquel, Frontline',
  'meds.dosage': 'Dosage',
  'meds.dosagePlaceholder': 'e.g. 1',
  'meds.timeslots': 'Timeslots',
  'meds.addTime': '+ Add Time',
  'meds.type': 'Type',
  'meds.shapeCapsule': 'Capsule',
  'meds.shapeOval': 'Oval',
  'meds.shapeTwoPart': 'Two-part',
  'meds.shapeDiamond': 'Diamond',
  'meds.shapeRound': 'Round',
  'meds.shapeFlat': 'Flat',
  'meds.shapeTriangle': 'Triangle',
  'meds.pillColour': 'Pill Colour',
  'meds.customColour': 'Custom colour',
  'meds.fillAllFields': 'Please fill all fields including at least one timeslot',
  'meds.edit': 'Edit',
  'meds.delete': 'Delete',
  'meds.duplicate': 'Duplicate',
  'meds.dropHere': 'Drop here to move',
  'meds.editMedication': 'Edit Medication',
  'meds.saveChanges': 'Save Changes',
  'contacts.edit': 'Edit',
  'contacts.delete': 'Delete',
  'contacts.editContact': 'Edit Contact',
  'contacts.addContact': 'Add Contact',
  'contacts.cancel': 'Cancel',
  'contacts.saveChanges': 'Save Changes',
  'contacts.saveContact': 'Save Contact',
  'contacts.name': 'Name',
  'contacts.phoneNumber': 'Phone Number',
  'contacts.email': 'Email',
  'contacts.nephrologist': 'Vet',
  'contacts.pharmacy': 'Groomer',
  'contacts.emergency': 'Emergency',
  'contacts.other': 'Other',
  'contacts.nameRequired': 'Name is required',
  'contacts.phoneRequired': 'Phone number is required',
  'contacts.deleteContact': 'Delete Contact',
  'contacts.deleteContactMsg': 'Are you sure you want to remove this contact from your care team?',
  'contacts.addNewContact': 'Add New Contact',
  'contacts.noContacts': 'No contacts added yet',
  'contacts.addCareTeam': 'Tap the button above to add your care team',
  'contacts.sortRecent': 'Most recent',
  'contacts.sortAlpha': 'Alphabetical',
  'records.shareCard': 'Share card',
  'records.undoObservation': 'Undo observation',
  // Notification settings
  'options.notifications': 'Notifications',
  'options.notificationsAll': 'All',
  'options.notificationsLogs': 'Logs',
  'options.notificationsMeds': 'Meds',
  'options.notificationsNone': 'None',
  'options.subscription': 'Subscription',
  'options.subscriptionSubtitle': 'Billing timeline and renewal details.',
  'options.subscriptionPlan': 'Plan',
  'options.subscriptionStatus': 'Status',
  'options.subscriptionStarted': 'Started',
  'options.subscriptionNextPayment': 'Next payment',
  'options.subscriptionExpires': 'Expires',
  'options.subscriptionNoActive': 'No active subscription',
  'options.subscriptionUnavailable': 'Not available',
  'account.title': 'Settings',
  'account.subtitle': 'Manage your profile, app preferences, reminders, subscription, and privacy.',
  'account.profile': 'Profile',
  'account.profileSubtitle': 'Your name, pet details & medical card',
  'account.profileSaved': 'Profile saved.',
  'account.profileSaveError': 'Failed to save profile. Please try again.',
  'account.savingProfile': 'Saving…',
  'account.saveProfile': 'Save Profile',
  'account.openDashboard': 'Open Dashboard',
  'account.starterTrial': 'Starter (Trial)',
  'account.expired': 'Expired',
  'account.loading': 'Loading…',
  'account.trialDaysLeft': 'Trial — {days} day{s} left',
  'account.expiredDaysLeft': 'Expired — {days} day{s} to resubscribe',
  'account.currentPlan': 'Current Plan',
  'account.fetchingBilling': 'Fetching your latest billing details.',
  'account.manageSubscription': 'Manage Subscription',
  'account.security': 'Account & Security',
  'account.memberSince': 'Member since',
  'account.lastLogin': 'Last login',
  'account.passwordResetSent': 'Password reset email sent — check your inbox.',
  'account.resetPassword': 'Reset Password',
  'account.resetPasswordEmailError': 'Could not send password reset email. Please try again.',
  'account.deleteRequiresRecentLogin': 'For security, please sign out and sign back in before deleting your account.',
  'account.deleteFailed': 'Failed to delete account. Please try again.',
  'account.deleting': 'Deleting…',
  'account.dataPrivacy': 'Data & Privacy',
  'account.exportDescription': 'You can export all data tied to your account as a CSV file.',
  'account.preparingExport': 'Preparing Export…',
  'account.downloadAllData': 'Download All My Data',
  'options.notificationSettings': 'Reminders',
  'options.remindersSubtitle': 'Medication alerts & push notification settings',
  'options.permissions': 'Permissions:',
  'options.activate': 'Activate:',
  'options.logReminderTimes': 'Log reminder times:',
  'options.logReminderTime': 'Reminder time:',
  'options.permissionGrant': 'Grant Permission',
  'options.browserBlockedHelp': 'Notifications are blocked by your browser. To enable them, click the lock/info icon in your browser\'s address bar and allow notifications for this site.',
  'options.appOn': 'App: On',
  'options.appOff': 'App: Off',
  'options.browserAllowed': 'Browser: Allowed',
  'options.browserUnsupported': 'Browser: Unsupported',
  'options.browserBlocked': 'Browser: Blocked',
  'options.browserNotAsked': 'Browser: Not asked',
  'options.activityTitle': 'Activity',
  // Lab Glossary
  'guide.labGlossary.intro': 'Understand common lab markers in veterinary blood panels. This information is educational — always discuss your pet\'s results with your vet.',
  'guide.labGlossary.search': 'Search markers…',
  'guide.labGlossary.all': 'All',
  'guide.labGlossary.noMarkersFound': 'No markers found.',
  'guide.labGlossary.referenceRange': 'Typical reference range',
  'guide.labGlossary.note': '⚠️ Note',
  // Marker data
  'guide.labGlossary.marker.creatinine.name': 'Creatinine',
  'guide.labGlossary.marker.creatinine.abbr': 'CREA',
  'guide.labGlossary.marker.creatinine.category': 'Kidney & Urinary',
  'guide.labGlossary.marker.creatinine.why': 'A core kidney marker in dogs and cats. Higher values can suggest reduced kidney filtration, but can also rise with dehydration.',
  'guide.labGlossary.marker.creatinine.typical': 'Dog: ~0.5–1.8 mg/dL · Cat: ~0.8–2.4 mg/dL (lab dependent).',
  'guide.labGlossary.marker.creatinine.note': 'Always interpret with SDMA, BUN, urine concentration, and hydration status.',
  'guide.labGlossary.marker.egfr.name': 'SDMA',
  'guide.labGlossary.marker.egfr.abbr': 'SDMA',
  'guide.labGlossary.marker.egfr.category': 'Kidney & Urinary',
  'guide.labGlossary.marker.egfr.why': 'Symmetric dimethylarginine can rise earlier than creatinine and helps detect early kidney changes.',
  'guide.labGlossary.marker.egfr.typical': 'Usually <14 µg/dL in many pet labs.',
  'guide.labGlossary.marker.egfr.note': 'Persistent increases are more meaningful than a one-off value.',
  'guide.labGlossary.marker.bun.name': 'Blood Urea Nitrogen',
  'guide.labGlossary.marker.bun.abbr': 'BUN / Urea',
  'guide.labGlossary.marker.bun.category': 'Kidney & Urinary',
  'guide.labGlossary.marker.bun.why': 'BUN reflects protein waste handling. It can rise with kidney disease, dehydration, GI bleeding, or high-protein diets.',
  'guide.labGlossary.marker.bun.typical': 'Dog: ~7–27 mg/dL · Cat: ~16–36 mg/dL (lab dependent).',
  'guide.labGlossary.marker.tacrolimus.name': 'ALP (Alkaline Phosphatase)',
  'guide.labGlossary.marker.tacrolimus.abbr': 'ALP',
  'guide.labGlossary.marker.tacrolimus.category': 'Liver',
  'guide.labGlossary.marker.tacrolimus.why': 'ALP can increase with liver or bile duct disease, steroid exposure, and growth in young pets.',
  'guide.labGlossary.marker.tacrolimus.typical': 'Often ~20–150 U/L in adult dogs/cats (method dependent).',
  'guide.labGlossary.marker.tacrolimus.note': 'Mild isolated rises can be non-specific; trend and context matter.',
  'guide.labGlossary.marker.ciclosporin.name': 'GGT (Gamma-Glutamyl Transferase)',
  'guide.labGlossary.marker.ciclosporin.abbr': 'GGT',
  'guide.labGlossary.marker.ciclosporin.category': 'Liver',
  'guide.labGlossary.marker.ciclosporin.why': 'GGT helps assess bile flow and hepatobiliary disease, often interpreted alongside ALP and bilirubin.',
  'guide.labGlossary.marker.ciclosporin.typical': 'Often low in healthy pets; reference limits vary by lab.',
  'guide.labGlossary.marker.mmf.name': 'Total Protein',
  'guide.labGlossary.marker.mmf.abbr': 'TP',
  'guide.labGlossary.marker.mmf.category': 'Proteins & Other',
  'guide.labGlossary.marker.mmf.why': 'Total protein combines albumin and globulins and can reflect hydration, inflammation, or protein loss.',
  'guide.labGlossary.marker.mmf.typical': 'Dog: ~5.5–7.5 g/dL · Cat: ~6.0–8.0 g/dL.',
  'guide.labGlossary.marker.potassium.name': 'Potassium',
  'guide.labGlossary.marker.potassium.abbr': 'K+',
  'guide.labGlossary.marker.potassium.category': 'Electrolytes',
  'guide.labGlossary.marker.potassium.why': 'Potassium affects heart and muscle function. Abnormal values may occur with kidney/urinary disease, vomiting, diarrhea, or urinary blockage.',
  'guide.labGlossary.marker.potassium.typical': 'Dog/Cat commonly ~3.5–5.5 mmol/L.',
  'guide.labGlossary.marker.potassium.note': 'Urgent abnormalities can occur with blocked cats and severe dehydration.',
  'guide.labGlossary.marker.sodium.name': 'Sodium',
  'guide.labGlossary.marker.sodium.abbr': 'Na+',
  'guide.labGlossary.marker.sodium.category': 'Electrolytes',
  'guide.labGlossary.marker.sodium.why': 'Sodium reflects fluid balance and can shift with dehydration, endocrine disease, and kidney/urinary issues.',
  'guide.labGlossary.marker.sodium.typical': 'Dog/Cat commonly ~140–160 mmol/L.',
  'guide.labGlossary.marker.bicarbonate.name': 'Chloride',
  'guide.labGlossary.marker.bicarbonate.abbr': 'Cl−',
  'guide.labGlossary.marker.bicarbonate.category': 'Electrolytes',
  'guide.labGlossary.marker.bicarbonate.why': 'Chloride helps acid-base and hydration assessment, especially with sodium and bicarbonate.',
  'guide.labGlossary.marker.bicarbonate.typical': 'Dog/Cat commonly ~105–122 mmol/L.',
  'guide.labGlossary.marker.phosphate.name': 'Phosphorus',
  'guide.labGlossary.marker.phosphate.abbr': 'PHOS',
  'guide.labGlossary.marker.phosphate.category': 'Kidney & Urinary',
  'guide.labGlossary.marker.phosphate.why': 'Phosphorus often rises as kidney disease progresses and is important for CKD staging and nutrition planning.',
  'guide.labGlossary.marker.phosphate.typical': 'Dog: ~2.5–6.0 mg/dL · Cat: ~2.5–6.8 mg/dL.',
  'guide.labGlossary.marker.calcium.name': 'Calcium',
  'guide.labGlossary.marker.calcium.abbr': 'Ca',
  'guide.labGlossary.marker.calcium.category': 'Electrolytes',
  'guide.labGlossary.marker.calcium.why': 'Calcium is important for nerves, muscle, and bones. Values may change with kidney disease, cancer, endocrine disorders, or low albumin.',
  'guide.labGlossary.marker.calcium.typical': 'Total calcium often ~8.5–11.8 mg/dL (species/lab dependent).',
  'guide.labGlossary.marker.haemoglobin.name': 'Red Cell Status',
  'guide.labGlossary.marker.haemoglobin.abbr': 'HGB / HCT / RBC',
  'guide.labGlossary.marker.haemoglobin.category': 'CBC',
  'guide.labGlossary.marker.haemoglobin.why': 'Red cell measurements assess anemia or dehydration. Chronic kidney disease can reduce red blood cell production.',
  'guide.labGlossary.marker.haemoglobin.typical': 'Ranges vary by species and analyzer; use your report\'s HGB/HCT/RBC intervals.',
  'guide.labGlossary.marker.wbc.name': 'White Blood Cell Count',
  'guide.labGlossary.marker.wbc.abbr': 'WBC',
  'guide.labGlossary.marker.wbc.category': 'CBC',
  'guide.labGlossary.marker.wbc.why': 'WBC helps assess inflammation, infection, stress response, and some bone marrow disorders.',
  'guide.labGlossary.marker.wbc.typical': 'Dog roughly ~6–17 ×10⁹/L · Cat ~5–19 ×10⁹/L.',
  'guide.labGlossary.marker.wbc.note': 'Look at differential counts (neutrophils/lymphocytes/eosinophils) for full interpretation.',
  'guide.labGlossary.marker.platelets.name': 'Platelets',
  'guide.labGlossary.marker.platelets.abbr': 'PLT',
  'guide.labGlossary.marker.platelets.category': 'CBC',
  'guide.labGlossary.marker.platelets.why': 'Platelets support blood clotting. Low platelets may increase bleeding risk; false lows can occur from platelet clumping.',
  'guide.labGlossary.marker.platelets.typical': 'Commonly ~200–500 ×10⁹/L (method dependent).',
  'guide.labGlossary.marker.altAst.name': 'ALT / AST',
  'guide.labGlossary.marker.altAst.abbr': 'ALT / AST',
  'guide.labGlossary.marker.altAst.category': 'Liver',
  'guide.labGlossary.marker.altAst.why': 'ALT/AST are liver-associated enzymes. Increases can reflect liver cell injury, inflammation, toxins, or muscle injury (especially AST).',
  'guide.labGlossary.marker.altAst.typical': 'Lab-specific; ALT is usually the more liver-specific value in dogs and cats.',
  'guide.labGlossary.marker.uricAcid.name': 'Albumin',
  'guide.labGlossary.marker.uricAcid.abbr': 'ALB',
  'guide.labGlossary.marker.uricAcid.category': 'Proteins & Other',
  'guide.labGlossary.marker.uricAcid.why': 'Albumin is a key blood protein that can drop with chronic inflammation, protein-losing kidney/gut disease, or liver dysfunction.',
  'guide.labGlossary.marker.uricAcid.typical': 'Dog: ~2.6–4.0 g/dL · Cat: ~2.5–3.9 g/dL.',
  'guide.labGlossary.marker.hba1c.name': 'Glucose',
  'guide.labGlossary.marker.hba1c.abbr': 'GLU',
  'guide.labGlossary.marker.hba1c.category': 'Metabolic',
  'guide.labGlossary.marker.hba1c.why': 'Glucose helps screen for diabetes and stress hyperglycemia (common in cats).',
  'guide.labGlossary.marker.hba1c.typical': 'Dog: ~70–120 mg/dL · Cat: ~70–150 mg/dL.',
  'guide.labGlossary.marker.cmv.name': 'Globulin',
  'guide.labGlossary.marker.cmv.abbr': 'GLOB',
  'guide.labGlossary.marker.cmv.category': 'Proteins & Other',
  'guide.labGlossary.marker.cmv.why': 'Globulins can increase with inflammation/infection and decrease with some immune or protein-losing disorders.',
  'guide.labGlossary.marker.cmv.typical': 'Dog: ~2.0–3.8 g/dL · Cat: ~2.8–5.1 g/dL.',
  'guide.labGlossary.marker.cmv.note': 'Interpret with albumin and total protein (A:G ratio is often useful).',
  'guide.labGlossary.marker.bkv.name': 'Bilirubin',
  'guide.labGlossary.marker.bkv.abbr': 'TBIL',
  'guide.labGlossary.marker.bkv.category': 'Liver',
  'guide.labGlossary.marker.bkv.why': 'Bilirubin can rise with liver disease, bile duct obstruction, or increased red blood cell breakdown.',
  'guide.labGlossary.marker.bkv.typical': 'Usually low/near-zero in healthy pets (lab dependent).',
  'guide.labGlossary.marker.upcr.name': 'Urine Protein:Creatinine Ratio',
  'guide.labGlossary.marker.upcr.abbr': 'UPC / UPCR',
  'guide.labGlossary.marker.upcr.category': 'Kidney & Urinary',
  'guide.labGlossary.marker.upcr.why': 'UPC estimates how much protein is lost in urine and helps monitor kidney disease progression and response to treatment.',
  'guide.labGlossary.marker.upcr.typical': 'Dog/Cat: <0.2 non-proteinuric, 0.2–0.5 borderline, >0.5 proteinuric (context matters).',
  'guide.labGlossary.marker.c0d.name': 'Urine Specific Gravity',
  'guide.labGlossary.marker.c0d.abbr': 'USG',
  'guide.labGlossary.marker.c0d.category': 'Kidney & Urinary',
  'guide.labGlossary.marker.c0d.why': 'USG measures urine concentration and is essential for interpreting kidney values and hydration status.',
  'guide.labGlossary.marker.c0d.typical': 'Highly variable; persistently low USG with high kidney markers may indicate kidney dysfunction.',
  'guide.labGlossary.category.kidneyFunction': 'Kidney & Urinary',
  'guide.labGlossary.category.immunosuppressants': 'Chemistry',
  'guide.labGlossary.category.electrolytes': 'Electrolytes',
  'guide.labGlossary.category.bloodCount': 'CBC',
  'guide.labGlossary.category.liverFunction': 'Liver',
  'guide.labGlossary.category.metabolic': 'Metabolic',
  'guide.labGlossary.category.infections': 'Proteins & Other',
  // Register legal
  'register.byRegistering': 'By registering, you agree to our',
  'register.and': 'and',
  'register.termsOfService': 'Terms of Service',
  'register.privacyPolicy': 'Privacy Policy',
  // CSV headers
  'records.csv.date': 'Date',
  'records.csv.weight': 'Weight',
  'records.csv.fluidIn': 'Fluid In',
  'records.csv.urineOut': 'Urine Out',
  'records.csv.amRegistered': 'AM Registered',
  'records.csv.amBP': 'AM BP',
  'records.csv.amPulse': 'AM Pulse',
  'records.csv.amTemp': 'AM Temp',
  'records.csv.pmRegistered': 'PM Registered',
  'records.csv.pmBP': 'PM BP',
  'records.csv.pmPulse': 'PM Pulse',
  'records.csv.pmTemp': 'PM Temp',
  'records.csv.observations': 'Observations',
  'records.csv.healthDiary': 'Health Diary',
  // Roomies settings
  'options.roomies.description': 'Connect with other pet parents in your group. All activity is anonymous.',
  'options.roomies.nickname': 'Nickname',
  'options.roomies.nicknameMax': '(max 12 chars)',
  'options.roomies.nicknamePlaceholder': 'e.g. Phoenix',
  'options.roomies.beanColour': 'BEAN Colour',
  'options.roomies.groupCode': 'Group Code',
  'options.roomies.groupCodePlaceholder': 'Enter or share your group code',
  'options.roomies.groupCodeHint': 'Share this code with your hospital roomies so they can join your group.',
  'options.roomies.enableRoomies': 'Enable Roomies',
  'options.roomies.enableRoomiesHint': 'Allow your activity to appear in your group feed',
  'options.roomies.noChanges': 'No Changes to Save',
  'options.roomies.saveProfile': 'Save Roomie Profile',
  'options.roomies.saved': 'Roomie profile saved!',
  // Companionship (The Koda Fellowship)
  'companions.title': 'Companionship',
  'companions.pageTitle': 'The Koda Fellowship',
  'companions.subtitle': 'See how your pet stacks up against fellow companions worldwide.',
  'companions.publicView': 'Public View',
  'companions.publicViewHint': 'When on, your pet joins The Koda Fellowship leaderboard. Turn off to stay private — you can still see others.',
  'companions.publicViewOn': 'Visible on leaderboard',
  'companions.publicViewOff': 'Hidden from leaderboard',
  'companions.leaderboardTitle': 'Leaderboard',
  'companions.leaderboardEmpty': 'No companions yet — be the first to log!',
  'companions.leaderboardHint': 'Ranked by level and current streak. Tap an emoji to cheer them on.',
  'companions.you': 'You',
  'companions.rank': 'Rank',
  'companions.score': 'Score',
  'companions.levelShort': 'Lv {n}',
  'companions.streakShort': '{n}d streak',
  'companions.hiddenNotice': 'You’re hidden from the leaderboard. Turn on Public View in Settings to join.',
  'companions.tabAll': 'All-Time',
  'companions.tabWeek': 'This Week',
  'companions.weekXPShort': '+{n} XP this week',
  'companions.leaderboardEmptyWeek': 'No XP earned this week yet — log your vitals to climb the board!',
  'companions.leaderboardHintWeek': 'Ranked by XP gained since Monday. Resets weekly.',
  'companions.story.title': 'Companion Story',
  'companions.story.modalTitle': 'Your Companion Story',
  'companions.story.hint': 'Pick a chip and write a short note. It shows beneath your row on the leaderboard.',
  'companions.story.placeholder': 'What’s new with your companion?',
  'companions.story.save': 'Save story',
  'companions.story.edit': 'Edit story',
  'companions.story.clear': 'Clear story',
  'companions.story.expiresIn': 'Expires in {n}d',
  'companions.story.recovered': 'Recovered',
  'companions.story.vaccinated': 'Just vaccinated',
  'companions.story.grooming': 'Fresh trim',
  'companions.story.vetVisit': 'Vet visit',
  'companions.story.newTreat': 'New treat',
  'companions.story.birthday': 'Birthday!',
  'companions.story.feelingGreat': 'Feeling great',
  'companions.story.restingUp': 'Resting up',
  'companions.story.newHome': 'New home',
  // Bean page
  'bean.back': 'Back',
  'bean.level': 'Level',
  'bean.yourBean': 'Your BEAN',
  'bean.dailyStreak': 'Daily Streak',
  'bean.current': 'Current',
  'bean.best': 'Best',
  'bean.totalXP': 'Total XP',
  'bean.streakZero': 'Log your vitals today to start your streak!',
  'bean.last30Days': 'Last 30 days',
  'bean.roomies': 'Companionship',
  'bean.active': 'Active',
  'bean.connectText': 'Connect with fellow pet parents around the world. Cheer each other on as you climb the leaderboard — anonymously.',
  'bean.setupRoomies': 'Turn on Public View in Settings → Companionship to appear on the leaderboard.',
  'bean.roomiesSettings': 'Companion settings',
  'bean.preview': 'Preview',
  'bean.noActivity': 'No companions yet — they’ll appear here as they log.',
  'bean.keepGoing': 'Keep going!',
  'bean.justNow': 'just now',
  'bean.minsAgo': '{n}m ago',
  'bean.hoursAgo': '{n}h ago',
  'bean.daysAgo': '{n}d ago',
  'bean.levelName.seedling': 'Seedling',
  'trial.endsToday': 'Your trial ends today — upgrade now to keep your data.',
  'trial.endsIn': 'Trial ends in {days} day{s} — upgrade to keep access.',
  'trial.upgrade': 'Upgrade',
  'trial.dismiss': 'Dismiss',
  'layout.offlineBanner': "You're offline — changes will sync when you reconnect",
  'layout.reconnectSyncing': 'Back online — syncing {n} queued item(s)…',
  'layout.reconnectSynced': 'All changes synced ✓',
  'splash.preparing': 'Getting things ready for you...',
  'bean.levelName.sprouting': 'Scout',
  'bean.levelName.budding': 'Sidekick',
  'bean.levelName.rooted': 'Buddy',
  'bean.levelName.thriving': 'Trailblazer',
  'bean.levelName.flourishing': 'Caretaker',
  'bean.levelName.resilient': 'Protector',
  'bean.levelName.champion': 'Champion',
  'bean.levelName.guardian': 'Hero',
  'bean.levelName.legend': 'Legend',
  'bean.feed.dailyLog': "logged their pet's vitals today",
  'bean.feed.dailyLogStreak': "logged their pet's vitals 🔥 {n}-day streak",
  'bean.feed.streakMilestone': 'hit a {n}-day streak! 🎉',
  'bean.feed.guideArticle': 'read a guide article',
  'bean.feed.joinedGroup': 'joined the group',
  'bean.feed.changedLook': 'updated their BEAN look 🎨',
  'bean.celebration.levelUpTitle': 'Level {level}! 🎉',
  'bean.celebration.streakTitle': '{streak}-Day Streak! 🔥',
  'bean.celebration.levelUpBody': "You've reached {name}. Keep it up!",
  'bean.celebration.streakBody': '{streak} days in a row — incredible consistency!',
  // Notifications
  'notifications.medReminder': 'Medication Reminder',
  'notifications.medReminderBody': 'Time to take: {meds}',
  'notifications.dailyReminder': 'Daily Log Reminder',
  'notifications.dailyReminderBody': "You haven't logged any data today. Recording your pet's vitals helps track their health progress.",
  'notifications.alarmTitle': '💊 Medication Reminder',
  'notifications.alarmBody': 'Time to take {name} ({dosage})',
  // Guide / Library page
  'guide.articles': 'Articles',
  'guide.subtitle': 'Guides, tools & your pet\'s records.',
  'guide.resources': 'Resources',
  'guide.minRead': 'min read',
  'guide.unlocksInDay': 'Unlocks in {n} day',
  'guide.unlocksInDays': 'Unlocks in {n} days',
  'guide.category.contacts.title': 'Care Team Contacts',
  'guide.category.contacts.subtitle': 'Vets, groomers & emergency contacts.',
  'guide.category.medical_card.title': 'Pet ID Card',
  'guide.category.medical_card.subtitle': "Your pet's ID card.",
  'guide.category.emergency.title': 'Emergency Vet Finder',
  'guide.category.emergency.subtitle': 'Find nearest emergency veterinary care now.',
  'guide.category.how_to.title': 'How To: Check Vitals',
  'guide.category.how_to.subtitle': 'Step-by-step checks by animal type.',
  'guide.category.hygiene.title': 'Hygiene',
  'guide.category.hygiene.subtitle': 'Grooming, dental care & coat health',
  'guide.category.exercise.title': 'Exercise',
  'guide.category.exercise.subtitle': 'Activity, play & breed-specific exercise',
  'guide.category.wellbeing.title': 'Wellbeing',
  'guide.category.wellbeing.subtitle': 'Behaviour, mood & everyday habits',
  'guide.category.food.title': 'Nutrition',
  'guide.category.food.subtitle': 'Feeding, diet & portion guidance',
  'guide.category.nutrition.title': 'Nutrition',
  'guide.category.nutrition.subtitle': 'Feeding, diet & portion guidance',
  'guide.category.sleep.title': 'Rest',
  'guide.category.sleep.subtitle': 'Naps, Nighttime & Calm Spaces',
  'guide.category.lab_glossary.title': 'Blood Tests Explained',
  'guide.category.lab_glossary.subtitle': "Understand your pet's results",
  'guide.category.vault.title': 'Vet Records',
  'guide.category.vault.subtitle': 'Upload, store, and access.',
  'guide.category.reminders.title': 'Reminders',
  'guide.category.reminders.subtitle': 'Medication alerts.',
  'guide.category.co-carers.title': 'Co-Carers',
  'guide.category.co-carers.subtitle': 'Share care with someone else.',
  // Auth — Register
  'register.disclaimerPrefix': 'I understand KodaCare is a pet health tracking tool, not a veterinary device, and I agree to the',
  'register.passwordStrength': 'Strength:',
  'register.rule.minLength': 'At least 8 characters',
  'register.rule.uppercase': 'Uppercase letter (A–Z)',
  'register.rule.lowercase': 'Lowercase letter (a–z)',
  'register.rule.number': 'Number (0–9)',
  'register.rule.special': 'Special character (!@#$…)',
  'register.strength.veryWeak': 'Very weak',
  'register.strength.weak': 'Weak',
  'register.strength.fair': 'Fair',
  'register.strength.strong': 'Strong',
  'register.strength.veryStrong': 'Very strong',
  'register.error.emailInUse': 'An account with this email already exists.',
  'register.error.invalidEmail': 'Please enter a valid email address.',
  'register.error.weakPassword': 'Password is too weak. Please choose a stronger one.',
  'register.error.network': 'Network error. Check your connection and try again.',
  'register.error.generic': 'Registration failed. Please try again.',
  'register.error.passwordRequirements': 'Please meet all password requirements.',
  'register.error.passwordsMustMatch': 'Passwords do not match.',
  'register.error.googleFailed': 'Google sign-in failed. Please try again.',
  // Auth — Login
  'login.error.incorrectCredentials': 'Incorrect email or password.',
  'login.error.notVerified': 'Your email address has not been verified. Check your inbox for the verification link.',
  'login.error.tooManyRequests': 'Too many attempts. Please try again later.',
  'login.error.network': 'Network error. Check your connection and try again.',
  'login.error.generic': 'Sign-in failed. Please try again.',
  'login.error.googleFailed': 'Google sign-in failed. Please try again.',
  // Medical Card
  'medcard.title': 'Pet ID Card',
  'medcard.saveTitleAttr': 'Save to profile',
  'medcard.saved': 'Saved ✓',
  'medcard.saving': 'Saving…',
  'medcard.save': 'Save',
  'medcard.shareAlt': 'Share as image',
  'medcard.shareFailed': 'Share failed',
  'medcard.hint': 'Tap any field to edit · Press Save to sync',
  'medcard.diary.title': 'Health Diary',
  'medcard.diary.placeholder': 'Write anything about today: Observations, general disposition, signs of good and bad health…',
  'medcard.diary.saved': 'Saved',
  'medcard.diary.saving': 'Saving…',
  'medcard.fullName': "Hooman's Name",
  'medcard.profession': "Pet's Name",
  'medcard.dob': 'Breed',
  'medcard.transplantDate': "Pet's Date of Birth",
  'medcard.hospital': 'Veterinary Practice',
  'medcard.processNo': 'Microchip No.',
  'medcard.surgeon': 'Primary Vet',
  'medcard.allergies': 'Allergies & Sensitivities',
  'medcard.avgWeight': 'Avg. Weight',
  'medcard.avgBP': 'Avg. Temperature',
  'medcard.medications': 'Current Meds',
  'medcard.placeholder.name': 'Tap to enter name',
  'medcard.placeholder.profession': 'Tap to enter name',
  'medcard.placeholder.dob': 'e.g. British Shorthair',
  'medcard.placeholder.hospital': 'Vet practice name',
  'medcard.placeholder.processNo': 'e.g. 985112345678901',
  'medcard.placeholder.surgeon': 'Vet name',
  'medcard.placeholder.allergies': 'None known',
  // Records — Today's Card
  'records.todaysCard': "Today's Card",
  'records.todaysCardComplete': "Today's Card complete!",
  'records.allThreeLogged': "All three steps logged — great care today!",
  'records.filesTooLarge': 'Skipped {n} file(s) larger than {mb}MB.',
  'records.stepLocked': 'Locked',
  // Records — new vitals fields
  'records.heartRate': 'Heart Rate',
  'records.respRate': 'Respiratory Rate',
  'records.heartRateRecorded': 'Heart Rate Recorded',
  'records.respRateRecorded': 'Respiratory Rate Recorded',
  'records.temperatureRecorded': 'Temperature Recorded',
  'records.undoHeartRate': 'Undo heart rate',
  'records.undoRespRate': 'Undo respiratory rate',
  'records.undoTemperature': 'Undo temperature',
  'records.wellnessCheck': 'Wellness',
  'records.mucousMembranes': 'Mucous Membranes',
  'records.mm.pink': 'Pink',
  'records.mm.red': 'Red',
  'records.mm.blue': 'Blue',
  'records.mm.white': 'White',
  'records.csv.heartRate': 'Heart Rate (bpm)',
  'records.csv.respRate': 'Resp. Rate (bpm)',
  'records.csv.mucousMembrane': 'Mucous Membrane',
  'records.csv.temp': 'Temp',
  'records.share.fluidIn': 'Fluid In',
  'records.countFor15s': 'Count beats for 15 seconds',
  'records.countBreathsFor15s': 'Count breaths for 15 seconds',
  'records.beats': 'beats',
  'records.breaths': 'breaths',
  'records.saveHeartRate': 'Save Heart Rate',
  'records.saveRespRate': 'Save Respiratory Rate',
  'records.temperature': 'Temperature',
  'records.saveTemperature': 'Save Temperature',
  // Trends
  'trends.showLast': 'Show the last:',
  // Guide wrappers
  'guide.renderError': 'Error rendering content:',
  // AppointmentCalendar
  'appt.kind.checkup': 'Vet Visit',
  'appt.kind.lab': 'Blood Test',
  'appt.kind.medication': 'Treatment',
  'appt.kind.other': 'Other',
  'appt.noAppointments': 'No appointments this day',
  'appt.upcoming': 'Upcoming',
  'appt.today': 'Today',
  'appt.addEvent': 'Add Event',
  'appt.editEvent': 'Edit Event',
  'appt.titleLabel': 'Title',
  'appt.titlePlaceholder': 'e.g. Vaccination booster',
  'appt.dateLabel': 'Date',
  'appt.timeLabel': 'Time',
  'appt.kindLabel': 'Type',
  'appt.doctorLabel': 'Vet / clinician',
  'appt.doctorPlaceholder': 'Optional',
  'appt.locationLabel': 'Location',
  'appt.locationPlaceholder': 'Optional',
  'appt.save': 'Save',
  'appt.cancel': 'Cancel',
  'appt.delete': 'Delete',
  'appt.deleteConfirm': 'Delete this event?',
  // Records share
  'records.weekOf': 'Week of',
  'records.share.title': 'KodaCare Daily Summary',
  'records.share.weight': 'Weight:',
  'records.share.morning': 'Morning:',
  'records.share.afternoon': 'Afternoon:',
  'records.share.fluidInOut': 'Fluid In: {fluidIn}  |  Urine Out: {fluidOut}',
  'records.share.note': 'Note:',
  'records.share.dataTitle': 'KodaCare Health Data',
  'records.share.dataText': 'My health data from KodaCare - {date}',
  // Notifications accessibility
  'notifications.dismiss': 'Dismiss',
  'notifications.bellLabel': 'Notifications',
  'notifications.settingsLabel': 'Notification settings',
  'notifications.fallbackTitle': 'KodaCare Reminder',
  'notifications.fallbackBody': 'You have a new reminder.',
  'fab.voiceHint': 'When you are ready, say "Start Timer Koda"',
  'fab.voicePhrase': 'start timer koda',
  // Onboarding walkthrough
  'walkthrough.polyName': 'Koda',
  'walkthrough.skip': 'Skip',
  'walkthrough.back': 'Back',
  'walkthrough.letsGo': "Let's go",
  'walkthrough.next': 'Next',
  'walkthrough.finish': 'Done! 🎉',
  'walkthrough.step0.title': "Hi, I'm Koda!",
  'walkthrough.step0.body': "Pleasure to meet you! I've prepared a welcome gift of +30 XP for you. More about that later\u2026 I'll show you around.",
  'walkthrough.step1.title': 'Daily Check-In',
  'walkthrough.step1.body': "Log your pet's vitals here as often as possible — every day is puurfect.",
  'walkthrough.step2.title': 'Health Trends',
  'walkthrough.step2.body': "See how your pet's health is changing over time with these charts.",
  'walkthrough.step3.title': 'Medications',
  'walkthrough.step3.body': 'Track medications, schedules and doses \u2014 never miss a dose again with reminders straight to your device.',
  'walkthrough.step4.title': 'Your Care Library',
  'walkthrough.step4.body': "Everything in one place — guides to earn XP, your pet's ID card, care team contacts, vet records, and more. Tap any resource to get started.",
  'walkthrough.step5.title': 'Your Progress',
  'walkthrough.step5.body': 'Track your streaks and XP progress here as well as meeting other carers in the Companionship tables.',
  'options.replayWalkthrough': 'Replay Walkthrough',
  // Co-carer / pet members
  'members.title': 'Co-Carers',
  'members.membersTitle': 'Current Members',
  'members.inviteTitle': 'Invite a Co-Carer',
  'members.inviteHint': 'Create a secure invite link and share it directly via iMessage, WhatsApp, or any messaging app.',
  'members.createLink': 'Create Invite Link',
  'members.copyLink': 'Copy Link',
  'members.copied': 'Copied!',
  'members.linkCopied': 'Link copied — share it with your co-carer.',
  'members.inviteError': 'Failed to create invite. Please try again.',
  'members.pendingTitle': 'Pending Invites',
  'members.cancelInvite': 'Cancel',
  'members.owner': 'Owner',
  'members.remove': 'Remove access',
  'members.confirmRemove': 'Remove {name} as a co-carer?',
  'members.joinedOn': 'Joined',
  'members.sentOn': 'Sent',
  'members.loading': 'Loading…',
  'members.noMembers': 'No members yet.',
  'members.viewOnlyNotice': "You are a co-carer for this pet. Only the owner can manage access.",
  'members.coCarers': 'Co-Carers',
  'members.coCarersSubtitle': 'Share care for this pet with someone else',
  'members.transferTitle': 'Transfer Ownership',
  'members.transferHint': "Transfer full ownership of {petName}'s profile to another KodaCare user. The recipient must have an active subscription. You will remain as a co-carer after the transfer.",
  'members.transferWarning': 'This action cannot be undone. You will lose owner privileges for this pet.',
  'members.transferEmail': 'Recipient email address',
  'members.transferSelectCarer': 'Quick-select a current co-carer:',
  'members.transferAction': 'Transfer',
  'members.transferConfirm': 'Transfer ownership of {petName} to {email}? This cannot be undone.',
  'members.transferSuccess': 'Ownership transferred. You are now a co-carer for this pet.',
  'members.transferError': 'Could not transfer ownership. Please try again.',
  'coCarer.removedNotice.title': 'You’ve been removed',
  'coCarer.removedNotice.body': 'The owner has removed you as a co-carer for {petName}. This pet’s profile and data will no longer appear in your account.',
  'coCarer.removedNotice.ok': 'OK',
  // Dose claiming
  'doses.markAsGiven': 'Mark as given',
  'doses.givenBy': 'Given by',
  'doses.at': 'at',
  'doses.alreadyGiven': 'Already given',
};